import React from "react";
import CrmFilter from "./CrmFilter";
import "./Crm.css";

const CRMComponent = (props) => {
  return (
    <>
      <CrmFilter state={props.state} />
    </>
  );
};

export default CRMComponent;
